import styles from './details-list-item.module.scss';
import cn from 'classnames';
import React from 'react';

type Props = {
  className?: string;
  children?: React.ReactNode;
  term: string;
  value: string;
};

export const DetailsListItem = ({ className, term, value }: Props) => {
  return (
    <li className={cn(styles.detailsListItemBox, className)}>
      {[term, value].join(' - ')}
    </li>
  );
};
